var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"items":_vm.items,"value":_vm.selectedItem,"menu-props":"auto","prepend-icon":"mdi-clock-outline","error-messages":_vm.errorMessages,"label":_vm.label,"disabled":_vm.disabled},on:{"change":_vm.onChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }